const model = {
    userDetails: null,
    loading: false,
    error: null,
};

export default model;